<template>
	<div id="overzicht">
		<nav class="level">
			<div class="level-left">
				<div class="level-item">
					<p class="subtitle is-3">Overzicht Opleidingen</p>
				</div>
			</div>
		</nav>

		<div class="columns">
			<div class="column"></div>
			<div class="column is-6">
				<b-field label="Zoek naar een school">
					<b-autocomplete
						v-model="name"
						placeholder="e.g. OSBOD ..."
						size="is-large"
						:keep-first="false"
						:open-on-focus="true"
						:data="filteredDataObj"
						field="name"
						icon="magnify"
						icon-pack="mdi"
						@focus="clearSchools()"
						@select="option => selected_schools = option.id"
					></b-autocomplete>
				</b-field>
			</div>

			<div class="column"></div>
		</div>
		<hr />
		<nav class="level">
			<div v-for="items in study_toc" :key="items.key" class="level-item">
				<a v-if="items.disabled" class="button is-info" :href="items.href" disabled>{{items.key}}</a>
				<a v-else class="button is-info" :href="items.href">{{items.key}}</a>
			</div>
		</nav>

		<div class="columns" v-for="studie in studies_alpha" :key="studie.id">
			<div class="column">
				<hr :id="studie.id" />
				{{studie.id}}
				<ul id="example-1">
					<template v-if="isSchool">
						<li v-for="item in studie.studies" :key="item.study_id">
							<router-link
								:to="{ name: 'details', params: { id: item.study_id, school_id: item.school_id }}"
							>{{ item.tbl_sys_study.name }}</router-link>
						</li>
					</template>
					<template v-else>
						<li v-for="item in studie.studies" :key="item.id">
							<router-link :to="{ name: 'details', params: { id: item.id, school_id: 0}}">{{ item.name }}</router-link>
						</li>
					</template>
				</ul>
			</div>
		</div>
	</div>
</template>
 <script>
import { API_ROOT } from "../../config";
import Axios from "axios";
//import Cookies from "js-cookie";
import _ from "lodash";

var instance = Axios.create({
	baseURL: API_ROOT,
	timeout: 60000
});

export default {
	name: "overzicht",
	components: {},
	data() {
		return {
			schoolyear: [],
			schools: [],
			name: "",
			isSchool: false,
			selected_schools: null,
			loading_schools: false,
			selected_schoolyear: 10,
			loading_schoolyear: false,
			studies: [],
			toc: [],
			study_toc: [],
			studies_alpha: []
		};
	},
	created() {
		// fetch the data when the view is created and the data is
		// already being observed
		//his.fetchData();

		this.getSchoolyear();
		this.getSchool();
		//this.getStudies();
		this.selected_schools = 0;
	},
	watch: {
		selected_schools(val) {
			console.log("school_id:" + val);

			if (val > 0) {
				this.getStudies(val);
			} else {
				this.isSchool = false;
				this.getStudiesAll();
			}
		}
	},
	computed: {
		filteredDataObj() {
			return this.schools.filter(option => {
				return option.name.toString().indexOf(this.name) >= 0;
			});
		}
	},
	methods: {
		selectSchool: function(option) {
			console.log("select school");
			this.selected_schools = option.id;

		},
		clearSchools: function() {
			console.log("Clear this shit");
			this.name = "";
		},
		getSchoolyear: function() {
			var self = this;
			this.loading_schoolyear = true;
			instance.get("/schoolyear/all").then(function(response) {
				console.log(response.data);

				self.schoolyear = response.data;
				self.loading_schoolyear = false;
				console.log(self.schoolyear);
			});
		},
		getSchool: function() {
			var self = this;
			this.loading_schools = true;
			instance.get("/school/all").then(function(response) {
				self.schools = _.filter(response.data, ["schooltype_id", 6]);
				self.schools;
				self.loading_schools = false;
				self.selected_schools = 0;
				console.log(self.schools);
			});
		},
		getStudiesAll: function() {
			var self = this;
			//var path = "/schoolsectorstudy/school/" + val;
			var path = "/studies/all";
			self.toc = [];
			self.study_toc = [];
			self.studies_alpha = [];
			instance.get(path).then(function(response) {
				self.studies = _.orderBy(response.data, ["name"], ["asc"]);
				console.log(self.studies);
				self.study_toc = self.genCharArray("A", "Z");

				for (let i = 0; i < self.studies.length; i++) {
					const element = self.studies[i];

					self.toc.push(element.name.charAt(0));
					self.toc = _.uniq(self.toc);
				}

				for (let j = 0; j < self.study_toc.length; j++) {
					const element = self.study_toc[j];

					self.studies_alpha.push({
						id: element.key,
						studies: _.filter(self.studies, function(o) {
							return o.name.charAt(0) == element.key;
						})
					});

					//console.log(self.studies_alpha.studies.);
				}
			});
		},
		getStudies: function(val) {
			this.isSchool = true;
			var self = this;
			var path = "/schoolsectorstudy/school/" + val;
			//var path = "/studies";
			self.toc = [];
			self.study_toc = [];
			self.studies_alpha = [];
			instance.get(path).then(function(response) {
				self.studies = _.orderBy(
					response.data,
					["tbl_sys_study.name"],
					["asc"]
				);
				console.log(self.studies);
				self.study_toc = self.genCharArray("A", "Z");

				for (let i = 0; i < self.studies.length; i++) {
					const element = self.studies[i];

					self.toc.push(element.tbl_sys_study.name.charAt(0));
					self.toc = _.uniq(self.toc);
				}

				for (let j = 0; j < self.study_toc.length; j++) {
					const element = self.study_toc[j];

					self.studies_alpha.push({
						id: element.key,
						studies: _.filter(self.studies, function(o) {
							return o.tbl_sys_study.name.charAt(0) == element.key;
						})
					});
				}
			});
		},
		genCharArray(charA, charZ) {
			var a = [],
				i = charA.charCodeAt(0),
				j = charZ.charCodeAt(0);
			for (; i <= j; ++i) {
				a.push({
					key: String.fromCharCode(i),
					href: "#" + String.fromCharCode(i),
					disabled: false
				});
			}
			a.push({ key: "#", href: "", disabled: false });
			return a;
		},
		navigate(destination) {
			this.$router.push({
				path: destination
			});
		}
	}
};
</script>

 <!-- Add "scoped" attribute to limit CSS to this component only -->
 <style scoped>
</style>
